const inkeep_ai_bot = {
    intro_message: 'Hi，我是Logto人工智慧！\n\n我是一個從文檔、幫助文章和其他內容中訓練出來的人工智慧助手。\n\n問我任何關於 `Logto` 的問題。',
    chat_placeholder: '向Logto人工智慧詢問問題以獲取分步指南',
    disclaimer_label: 'Logto人工智慧免責聲明',
    disclaimer_tooltip: '回覆內容由人工智慧生成，可能需要進一步確認。',
    example_questions_label: '範例問題',
    example_questions: ['Logto 設置的快速入門指南', '配置多租戶架構', '如何整合用戶資料？'],
    stop: '停止',
    clear: '重新開始',
    get_help: '獲取幫助',
    copy_chat: '複製',
    ask_ai_label: '詢問人工智慧',
    contact: '聯繫我們',
    discord: 'Discord社群',
};
export default Object.freeze(inkeep_ai_bot);
